import { render } from "./events-posts.vue?vue&type=template&id=7a51e9a0&scoped=true"
import script from "./events-posts.vue?vue&type=script&lang=js"
export * from "./events-posts.vue?vue&type=script&lang=js"

import "./events-posts.vue?vue&type=style&index=0&id=7a51e9a0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\rados\\Local Sites\\somernova\\app\\public\\wp-content\\themes\\somernovaTheme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a51e9a0"]])

export default __exports__